import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'

Vue.use(VueScrollTo, {"easing":"linear","duration":100})

export default function (ctx, inject) {
    inject('scrollTo', VueScrollTo.scrollTo)
}
